import {UserGuide} from '@/pages/Template/components/HeaderExtraItems'
export default function NoCountriesPage(): React.JSX.Element {
  return (
    <div className="flex w-full" data-testid="no-countries-page" data-cy="no-countries-page">
      <div>You do not have any Markets assigned. Please follow the instructions to request access.</div>
      <div className="-ml-2 -mt-2">
        <UserGuide iconColor="text-black" openAccordionIndex={7} />
      </div>
    </div>
  )
}
